export default "__VITE_ASSET__c05d47ac__"